<script>
export default {
    name: "InvoiceDetails",

    data() {

        return {
            claimDocuments: [],
        };
    },

    props: {

        showModal: Boolean,
        invoice: Object,
        items: Array,
        patient: Object,
    },

    computed: {

        totalInsuranceAmt() {

            if(!this.items.length) return 0;

            const filteredItems = this.items.filter(invItem => invItem.insuranceAmountPaid);

            if(!filteredItems.length) return 0;

            const invItems = filteredItems.map(item => parseFloat(item.insuranceAmountPaid));

            return invItems.reduce((cost, accTotal) => cost + accTotal);
        },
    },

    methods: {

        printInvoiceDetails() {
            let url = `/reports/accounts-finance/invoice-details/print`;
                url += `?patientID=${this.patient.patientID}`;
                url += `&invoiceNo=${this.invoice.invoiceNo}`;

            window.open(url, '_blank', `ReportPrint`,);
        },

        printInvoiceReceipt() {
            let url = `/billing/receipt-invoice-insurance/print`;
                url += `/${this.patient.patientID}/${this.invoice.invoiceNo}`;

            window.open(url, '_blank', `InvoiceReceiptPrint`);
        },

    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12 md:w-2/3">
  <template v-slot:title>
    <h5 class="font-bold text-base">Invoice Details </h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-col items-center">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap p-2 bg-gray-400">
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">Patient: 
               <span class="text-blue-800">{{ patient.names }}</span></h5>
            </div>
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">OP File No: 
               <span class="text-blue-800">{{ patient.opfileNo || `-` }}</span></h5>
            </div>
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">IP File No: 
               <span class="text-blue-800">{{ patient.ipfileNo || `-` }}</span></h5>
            </div>
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">Visit No: 
               <span class="text-blue-800">{{ patient.visitNo }}</span></h5>
            </div>
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">Invoice NO: 
               <span class="text-blue-800">{{ invoice.invoiceNo }}</span></h5>
            </div>
            <div class="md:w-1/3 w-full p-1">
                <h5 class="font-bold">Organization: 
               <span class="text-blue-800">-</span></h5>
            </div>
        </div>
        <div class="w-full overflow-auto mt-1">
            <table class="table table-bordered table-hover">
                <thead class="bg-blue-500 text-xs text-white">
                    <tr>
                        <th class="p-tiny">#</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">User</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Cost</th>
                        <th class="p-tiny">Insurance Amt</th>
                        <th class="p-tiny">Claim No</th>
                    </tr>
                </thead>
                <tfoot class="text-xs">
                      <tr>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny" colspan="2">Total</th>
                          <th class="p-tiny">
                              {{ totalInsuranceAmt | numberFormat }}</th>
                          <th class="p-tiny"></th>
                      </tr>
                </tfoot>
                <tbody class="text-xs">
                    <tr v-for="(invoiceItem, idx) in items" :key="idx">
                        <td class="p-tiny">{{ invoiceItem.invoiceDetailID }}</td>
                        <td class="p-tiny">{{ invoiceItem.item }}</td>
                        <td class="p-tiny">{{ invoiceItem.description }}</td>
                        <td class="p-tiny">{{ invoiceItem.userName }}</td>
                        <td class="p-tiny">{{ invoiceItem.qty }}</td>
                        <td class="p-tiny">{{ invoiceItem.charge | numberFormat }}</td>
                        <td class="p-tiny">{{ invoiceItem.insuranceAmountPaid | numberFormat }}</td>
                        <td class="p-tiny">{{ invoiceItem.claimNo || `-` }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs mr-6 rounded" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        class="btn-info btn-sm text-xs mr-6 rounded" 
        @click="printInvoiceReceipt">
            <i class="fa fa-print"></i> Print Invoice</button>
    <!-- <button 
        class="btn-primary btn-sm text-xs rounded" 
        @click.prevent="printInvoiceDetails">
            <i class="fa fa-print"></i> Print Invoice</button> -->
  </template>
</tail-modal>
</template>